import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      opacity: "0.8",
      d: "M13.9027 6C14.7731 6 15.2959 6.99667 14.8197 7.74834L9.91707 15.4881C9.4847 16.1706 8.51528 16.1706 8.08291 15.4881L3.18025 7.74834C2.70411 6.99667 3.22691 6 4.09733 6H13.9027Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }